import { createSharedStoreHook } from 'shared-store-hook';

export const useDarkMode = createSharedStoreHook({ initalState: false });
